<template>
  <div style="padding: 10px;">
    <div class="col-md-12">
      <div class="row">
        <div class="col-md-10">
          <h4>Grupos</h4>
        </div>
        <div class="col-md-2">
          <button
            class="btn btn-success"
            @click="cadastro()"
            style="margin-right: 5px; 
                  border-color: rgb(0, 150, 136); color: rgb(0, 150, 136);margin-top: 21px;float: right;margin-right: 22px;"
          >Cadastrar</button>
        </div>
      </div>
    </div>

    <div class="col-md-12" v-if="sucessoDelete">
        <div class="card" style="background-color: rgb(50 170 159) !important;color: #fff !important;margin-bottom: 20px !important;" >
            <div class="card-body">
                <div class="row">
                  <div class="col-md-12" >
                      {{sucessoDelete}}
                  </div>
                </div>
            </div>  
        </div> 
    </div>
    <div class="col-md-12" v-if="failDelete">
        <div class="card" style="background-color: rgb(170 72 50) !important;color: #fff !important;margin-bottom: 20px !important;" >
            <div class="card-body">
                <div class="row">
                  <div class="col-md-12" >
                      {{failDelete}}
                  </div>
                </div>
            </div>  
        </div> 
    </div>
    
    
    <div class="col-md-12">
      <vue-good-table
        :columns="columns"
        :rows="Permissao"
        :lineNumbers="false"
        :search-options="{
          enabled: true,
          placeholder: 'Pesquisar',
        }"
        :pagination-options="{
              enabled: true,
              mode: 'records',
              mode: 'pages',
              perPage: 5,
              position: 'bottom',
              perPageDropdown: [5, 10, 15],
              dropdownAllowAll: false,
              nextLabel: 'Próximo',
              prevLabel: 'Anterior',
              rowsPerPageLabel: 'Linhas por página',
              ofLabel: 'de',
              pageLabel: 'pagina', 
              allLabel: 'All',
        }"
      > 
      
        <template slot="table-row" slot-scope="props">
          <div v-if="props.column.field == 'status'">
            <switch-button
              v-model="props.row.status"
              color="#253DB9"
              :meuid="props.row.id"
              modulo="permissao"
              funcao="exibirStatus"
            ></switch-button>
          </div>

          <span v-if="props.column.field == 'action'">
            <button class="btn btn-primary" @click="editar(props.row)" style="margin-right:5px;">
              <i class="fa fa-pencil-square-o"></i>
            </button>
            <button class="btn btn-danger" @click="delete_option(props.row.id)">
              <i class="fa fa-times"></i>
            </button>
          </span>
          <!--<span v-else>
                   {{props.formattedRow[props.column.field]}}
          </span>-->
          <span v-else>
            <span v-if="props.column.field != 'status'">{{props.formattedRow[props.column.field]}}</span>
          </span>
        </template>
        
      </vue-good-table>
    </div>

  </div>
  
</template>

<script>
import "vue-good-table/dist/vue-good-table.css";
import { VueGoodTable } from "vue-good-table";
import axios from "axios";
import store from "src/store.js";
import "src/controller/sistema/permissaoController.js";
import SwitchButton from "src/components/switch.vue";

export default {
  name: "my-component",
  components: {
    VueGoodTable,
    SwitchButton,
  },
  data() {
    return {
      columns: [
        {
          label: "Nome",
          field: "nome",
        },
        {
          label: "Status",
          field: "status",
          hidden: true,
        },
        {
          label: "Ações",
          field: "action",
          sortable: false,
         
        },
        {
          label: "id",
          field: "id",
          hidden: true,
        },
      ],
      Permissao: [],
      per:[],
      result_detalhes: null,
      sucessoDelete:null,
      failDelete:null,
      user: {
        admin: null,
        admin_sistema: null,
      },
    };
  },
  methods: {
    cadastro(){
      this.$router.push({ name: "permissaocadastro" });
    },
    async delete_option(id) {
      try {
        this.$confirm("Deseja excluir?").then(() => {
          this.deletar(id);
        });
      } catch (e) {
        
      }
    },
    async deletar(id){
      try {
        //let me = await this.$me();
        this.failDelete = null;
        this.sucessoDelete = null;
        let data = await this.$permissaoDelete(id);
        if(data.msg == "Deletado com Sucesso!"){
          this.sucessoDelete = data.msg;
        }
        this.Permissao = [];
        this.listarTudo();
       } catch (e) {
        this.failDelete = e.response.data.msg;
      }
    },
    editar(row) {
      this.$router.push({ name: "permissaoeditar", params: { row: row } });
    },
    async listarTudo() {
      try {
        let data = await this.$listarPermissoes();
        this.per = data.data.reverse();
        //this.Permissao = data.data.reverse();
        this.per.forEach((array) => {
          this.filtro(array);
        });
      } catch (e) {}
    },
    async filtro(array) {
      try {
        let status;
        if (array.status == 1) {
          status = true;
        } else {
          status = false;
        }
        let nova_permissao = {
          hab_cidadao: array.hab_cidadao,
          tipo: array.tipoUsuario,
          hab_manifestacao: array.hab_manifestacao,
          hab_log: array.hab_log,
          hab_mod_departamento: array.hab_mod_departamento,
          hab_departamentos: array.hab_departamentos,
          id: array.id,
          nome: array.nome,
          status: status,
        };

        this.Permissao.push(nova_permissao);
        
      } catch (error) {}
    },
  },
  beforeMount() {
    try {
      this.listarTudo();
      this.user.admin = store.admin;
      this.user.admin_sistema = store.admin_sistema;
    } catch (e) {}
  },
};
</script>

